(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-mt-cifra]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.target.dataset.mtDone) return;
        entry.target.dataset.mtDone = '1';
        var target = parseFloat(entry.target.dataset.mtCifra);
        var decimals = entry.target.dataset.mtDecimales === 'true';
        var suffix = entry.target.dataset.mtSufijo || '';
        var start = 0;
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var current = start + (target - start) * progress;
          entry.target.textContent = (decimals ? current.toFixed(1) : Math.round(current)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (el) { obs.observe(el); });
  }

  function initHotspots() {
    document.querySelectorAll('[data-mt-hotspots]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return;
      wrap.dataset.mtInit = '1';
      var puntos = wrap.querySelectorAll('.mt-punto');
      puntos.forEach(function (punto) {
        var id = punto.dataset.mtTarget;
        var tarjeta = wrap.querySelector('[data-mt-tarjeta="' + id + '"]');
        if (!tarjeta) return;
        function abrir() {
          wrap.querySelectorAll('.mt-punto-tarjeta').forEach(function (t) { t.classList.remove('mt-activa'); });
          tarjeta.classList.add('mt-activa');
        }
        punto.addEventListener('mouseenter', abrir);
        punto.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = tarjeta.classList.contains('mt-activa');
          wrap.querySelectorAll('.mt-punto-tarjeta').forEach(function (t) { t.classList.remove('mt-activa'); });
          if (!isOpen) tarjeta.classList.add('mt-activa');
        });
      });
      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          wrap.querySelectorAll('.mt-punto-tarjeta').forEach(function (t) { t.classList.remove('mt-activa'); });
        }
      });
    });
  }

  function initAntesDespues() {
    document.querySelectorAll('[data-mt-antes-despues]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return;
      wrap.dataset.mtInit = '1';
      var asa = wrap.querySelector('.mt-ad-asa');
      var despues = wrap.querySelector('.mt-ad-despues');
      var arrastrando = false;

      function mover(clientX) {
        var rect = wrap.getBoundingClientRect();
        var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        asa.style.left = pct + '%';
        despues.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      }
      asa.addEventListener('mousedown', function () { arrastrando = true; });
      window.addEventListener('mouseup', function () { arrastrando = false; });
      window.addEventListener('mousemove', function (e) { if (arrastrando) mover(e.clientX); });
      asa.addEventListener('touchstart', function () { arrastrando = true; }, { passive: true });
      window.addEventListener('touchend', function () { arrastrando = false; });
      window.addEventListener('touchmove', function (e) {
        if (arrastrando && e.touches[0]) mover(e.touches[0].clientX);
      }, { passive: true });
      asa.addEventListener('keydown', function (e) {
        var rect = wrap.getBoundingClientRect();
        var current = parseFloat(asa.style.left) || 50;
        if (e.key === 'ArrowLeft') { mover(rect.left + rect.width * ((current - 5) / 100)); }
        if (e.key === 'ArrowRight') { mover(rect.left + rect.width * ((current + 5) / 100)); }
      });
    });
  }

  function initAnillo() {
    document.querySelectorAll('[data-mt-anillo]').forEach(function (svg) {
      if (svg.dataset.mtInit || !('IntersectionObserver' in window)) return;
      svg.dataset.mtInit = '1';
      var progreso = svg.querySelector('.mt-anillo-progreso');
      var pct = parseFloat(svg.dataset.mtAnillo) || 0;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var offset = 502 - (502 * pct) / 100;
            progreso.style.strokeDashoffset = offset;
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      obs.observe(svg);
    });
  }

  function initFaq() {
    document.querySelectorAll('.mt-faq-item').forEach(function (item) {
      if (item.dataset.mtInit) return;
      item.dataset.mtInit = '1';
      var boton = item.querySelector('.mt-faq-pregunta');
      if (!boton) return;
      boton.addEventListener('click', function () {
        var abierto = item.getAttribute('data-abierto') === 'true';
        item.setAttribute('data-abierto', abierto ? 'false' : 'true');
      });
    });
  }

  function initModalTallas() {
    document.querySelectorAll('[data-mt-abrir-modal]').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      var id = btn.getAttribute('data-mt-abrir-modal');
      var overlay = document.getElementById(id);
      if (!overlay) return;
      btn.addEventListener('click', function () { overlay.setAttribute('data-abierto', 'true'); });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target.hasAttribute('data-mt-cerrar-modal')) {
          overlay.setAttribute('data-abierto', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') overlay.setAttribute('data-abierto', 'false');
      });
    });
  }

  function initTodo() {
    initReveals();
    initCifras();
    initHotspots();
    initAntesDespues();
    initAnillo();
    initFaq();
    initModalTallas();
  }

  document.addEventListener('DOMContentLoaded', initTodo);
  document.addEventListener('shopify:section:load', initTodo);
})();
